import BaseAppError from './BaseAppError';

export default class UnknownQueryFetchError extends BaseAppError {
  constructor(message = 'Query fetch error') {
    super(message, true, true);
  }
}
